export const stages = ["Order Received", "Design", "Approval", "Production", "Dispatch", "Delivery"];

export const normalizeStage = (stage) => {
  if (!stage) return "Order Received";
  const s = String(stage).trim();
  const lower = s.toLowerCase();
  if (lower === "order received") return "Order Received";
  if (lower === "design") return "Design";
  if (lower === "client approval" || lower === "approval") return "Approval";
  if (lower === "production") return "Production";
  if (lower === "dispatch" || lower === "challan") return "Dispatch";
  if (["delivery", "delivered", "accounts", "invoice", "payment"].includes(lower)) return "Delivery";
  return s;
};

export const money = (n) =>
  (n || 0).toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });

export const compactMoney = (n) => {
  const v = Number(n || 0);
  if (v >= 10000000) return `₹${(v / 10000000).toFixed(1)}Cr`;
  if (v >= 100000) return `₹${(v / 100000).toFixed(1)}L`;
  if (v >= 1000) return `₹${(v / 1000).toFixed(1)}K`;
  return `₹${v.toFixed(0)}`;
};

export const badgeTone = (stage) => {
  const norm = normalizeStage(stage);
  if (["Production", "Delivered", "Delivery", "Completed"].includes(norm)) return "green";
  if (["Approval", "Client Approval", "In Transit", "On Hold"].includes(norm)) return "amber";
  if (["Rejected", "Failed", "Overdue", "Cancelled"].includes(norm)) return "red";
  return "blue";
};

export const errorMessage = (err, fallback = "An unexpected error occurred") => {
  if (!err) return fallback;
  if (typeof err === "string") return err;
  const detail = err.response?.data?.detail ?? err.message ?? err.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d === "object" && d !== null ? d.msg || JSON.stringify(d) : String(d))).join(", ");
  }
  if (typeof detail === "object" && detail !== null) {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return fallback;
};

export const testid = (s) => String(s).toLowerCase().replaceAll(/[^a-z0-9]+/g, "-");

export const getTodayDateString = () => {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const ORDER_WORKFLOW_STAGES = [
  "Order Received",
  "Design",
  "Approval",
  "Production",
  "Dispatch",
  "Delivery",
];

export const getStageIndex = (stage) => {
  if (!stage) return 0;
  const s = String(stage).trim().toLowerCase();
  if (s === "order received" || s === "order_received" || s === "new") return 0;
  if (s === "design" || s === "in progress") return 1;
  if (s === "approval" || s === "client approval" || s === "awaiting approval" || s === "approved") return 2;
  if (s === "production" || s === "sent to production") return 3;
  if (s === "dispatch" || s === "challan") return 4;
  if (["delivery", "delivered", "out for delivery", "in transit"].includes(s)) return 5;
  return -1;
};

export const getValidPreviousStages = (currentStage) => {
  const idx = getStageIndex(currentStage);
  if (idx <= 0) return [];
  return ORDER_WORKFLOW_STAGES.slice(0, idx);
};

export const formatStageHistoryDateTime = (val) => {
  if (!val) return "—";
  try {
    const d = new Date(val);
    if (isNaN(d.getTime())) return String(val);

    const day = String(d.getDate()).padStart(2, "0");
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const month = months[d.getMonth()];
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, "0");

    return `${day} ${month} ${year}, ${formattedHours}:${minutes} ${ampm}`;
  } catch {
    return String(val);
  }
};

